export const SHIPPING_GROUP_LINKS = {
  base: "/app/shipping",
  picking: "/app/shipping/picking-list",
  shipping: "/app/shipping/shipping-list",
};
